import { Link, useNavigate, useParams, useLoaderData } from "react-router-dom";
import { useState, useEffect } from "react";

import { Who5Update } from "./Who5Update";

import { CreditoUpdate } from "../components/CreditoUpdate";

import { GananciasModal } from "../components/GananciasModal";

import * as APILOG from "../services/gananciaslog";

import * as APIUSER from "../services/user";

export function Who5PacienteEdit(props) {
  const who5 = useLoaderData();

  const navigate = useNavigate();
  const errorMessage = who5.message;

  const [who5ErrorMessage, setWho5ErrorMessage] = useState("");
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);

  const [isGananciasModalOpen, setIsGananciasModalOpen] = useState(false);
  const [gananciasMessage, setGananciasMessage] = useState("");

  const [isCreatingButton, setIsCreatingButton] = useState(false);

  const [credito, setCredito] = useState(0);
  const [pacienteId, setPacienteId] = useState(0);

  const [who5Resp, setWho5Resp] = useState(who5.meta?.who5Resp);
  const [metaFecha, setWho5Fecha] = useState(
    who5.meta?.metaFecha || new Date().toISOString().slice(0, 10)
  );

  const [who5Alegre, setWho5Alegre] = useState(who5.meta?.who5Alegre);
  const [who5Tranquilo, setWho5Tranquilo] = useState(who5.meta?.who5Tranquilo);
  const [who5Activo, setWho5Activo] = useState(who5.meta?.who5Activo);
  const [who5Despejado, setWho5Despejado] = useState(who5.meta?.who5Despejado);
  const [who5Interesan, setWho5Interesan] = useState(who5.meta?.who5Interesan);

  let { tratamientoId } = useParams();
  console.log(tratamientoId);

  let who5Id = who5.id;
  let whoStatus = who5.status;

  const who5Date = new Date(who5.date);
  const diffDate = Math.abs(new Date() - who5Date) / 36e5;

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        // Obtener los datos del usuario
        const currentUserData = await APIUSER.getCurrentUser();
        console.log(currentUserData);
        if (currentUserData) {
          setCredito(currentUserData?.meta?.credito);
          setPacienteId(currentUserData?.id);
        }
      } catch (error) {
        console.error("Error al obtener los datos del usuario:", error);
      }
    };

    fetchUserData();
  }, []);

  const submitWho5 = async (e) => {
    e.preventDefault();
    setWho5ErrorMessage(""); // Limpiar el mensaje de error previo
    setIsErrorModalOpen(false);
    setIsCreatingButton(true);
    try {
      // Crear un array con las 5 respuestas
      const who5Answers = [
        who5Alegre,
        who5Tranquilo,
        who5Activo,
        who5Despejado,
        who5Interesan,
      ];

      // Contar cuántas están respondidas
      const answeredQuestions = who5Answers.filter((val) => val !== "").length;
      const totalQuestions = who5Answers.length;
      const percentage = (answeredQuestions / totalQuestions) * 100;

      // Si no se ha respondido el 100% de preguntas, mostrar error
      if (percentage < 100) {
        setWho5ErrorMessage(
          "Para que podamos trabajar en tu recuperación y bienestar, necesitamos tus respuestas en todas las preguntas."
        );
        setIsErrorModalOpen(true);
        setIsCreatingButton(false);
        return; // Evitar el envío del formulario
      }

      await Who5Update(
        who5Resp,
        metaFecha,
        who5Alegre,
        who5Tranquilo,
        who5Activo,
        who5Despejado,
        who5Interesan,
        tratamientoId,
        pacienteId,
        who5Id
      ).then(
        (val) => {
          try {
            // Verificar que `credito` sea un número antes de sumarle 5
            const creditoFinal = typeof credito === "number" ? credito + 5 : 5;

            CreditoUpdate(creditoFinal, pacienteId).then(
              (val) => {
                console.log("Crédito actualizado:", val);

                const fechaActual = new Date().toISOString();
                APILOG.createGananciasLog(
                  fechaActual,
                  pacienteId,
                  "Completó el cuestionario WHO5. + 5€"
                )
                  .then((val) => {
                    console.log(val);
                    // window.location.replace(`../`);
                    setGananciasMessage(
                      "Ha obtenido 5€ y se lo hemos añadido a sus Ganancias"
                    );
                    setIsGananciasModalOpen(true);
                  })
                  .catch((error) => {
                    console.error("Error al crear ganancias log:", error);
                    // En caso de error, aun redirigimos o podemos mostrar un mensaje
                    // window.location.replace(`../`);
                    setGananciasMessage(
                      "Ha obtenido 5€ y se lo hemos añadido a sus Ganancias"
                    );
                    setIsGananciasModalOpen(true);
                  });
              },
              (error) => {
                console.log(error);
              }
            );
          } catch (err) {
            console.log(err);
          }
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id="content">
        {who5.length === 0 ? (
          <div>Cargando...</div>
        ) : errorMessage ? (
          <p>{errorMessage}</p>
        ) : who5.author !== pacienteId ? ( // Comprobación del autor
          <p>Error: No tienes permiso para editar este contenido.</p>
        ) : (
          <form
            id="formUpdatelement"
            className="newRadioButtons"
            onSubmit={submitWho5}
          >
            <fieldset id="disabledContainer">
              <div className="grid--2col">
                <div className="field">
                  <label htmlFor="metaFecha">Fecha visita</label>
                  <div className="control">
                    <input
                      className="input"
                      id="metaFecha"
                      required
                      type="date"
                      value={metaFecha}
                      onChange={(e) => setWho5Fecha(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <h3>Cuestionario de Bienestar</h3>
              <p>
                Ayúdanos a optimizar tu tratamiento y observa tu evolución.
                Completa el cuestionario y OBTÉN 5€ A CAMBIO.
              </p>
              <br></br>
              <p>
                Por favor, indica para cada una de las 5 afirmaciones cuál es la
                que mejor refleja CÓMO TE HAS SENTIDO DURANTE LOS ÚLTIMOS 30
                DÍAS.
              </p>
              <br></br>

              <div className="form-radio-container">
                <div className="grid--2-col">
                  <div className="radio-capt radio--6-col">
                    <p>Todo el tiempo</p>
                    <p>La mayor parte del tiempo</p>
                    <p>Más de la mitad del tiempo</p>
                    <p>Menos de la mitad del tiempo</p>
                    <p>Algo del tiempo</p>
                    <p>En ningún momento</p>
                  </div>
                </div>
                <div className="field">
                  <div className="control grid--2col">
                    <label className="radio-title" htmlFor="who5Alegre">
                      1. me he sentido alegre y con buen ánimo
                    </label>
                    <div className="radio--6-col">
                      <label className="radio" htmlFor="who5Alegre-5">
                        <input
                          id="who5Alegre-5"
                          name="who5Alegre"
                          type="radio"
                          value="5"
                          required
                          checked={who5Alegre === "5"}
                          onChange={(e) => setWho5Alegre(e.target.value)}
                        />
                        5
                      </label>
                      <label className="radio" htmlFor="who5Alegre-4">
                        <input
                          id="who5Alegre-4"
                          name="who5Alegre"
                          type="radio"
                          value="4"
                          required
                          checked={who5Alegre === "4"}
                          onChange={(e) => setWho5Alegre(e.target.value)}
                        />
                        4
                      </label>
                      <label className="radio" htmlFor="who5Alegre-3">
                        <input
                          id="who5Alegre-3"
                          name="who5Alegre"
                          type="radio"
                          value="3"
                          required
                          checked={who5Alegre === "3"}
                          onChange={(e) => setWho5Alegre(e.target.value)}
                        />
                        3
                      </label>
                      <label className="radio" htmlFor="who5Alegre-2">
                        <input
                          id="who5Alegre-2"
                          name="who5Alegre"
                          type="radio"
                          value="2"
                          required
                          checked={who5Alegre === "2"}
                          onChange={(e) => setWho5Alegre(e.target.value)}
                        />
                        2
                      </label>
                      <label className="radio" htmlFor="who5Alegre-1">
                        <input
                          id="who5Alegre-1"
                          name="who5Alegre"
                          type="radio"
                          value="1"
                          required
                          checked={who5Alegre === "1"}
                          onChange={(e) => setWho5Alegre(e.target.value)}
                        />
                        1
                      </label>
                      <label className="radio" htmlFor="who5Alegre-0">
                        <input
                          id="who5Alegre-0"
                          name="who5Alegre"
                          type="radio"
                          value="0"
                          required
                          checked={who5Alegre === "0"}
                          onChange={(e) => setWho5Alegre(e.target.value)}
                        />
                        0
                      </label>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <div className="control grid--2col">
                    <label className="radio-title" htmlFor="who5Tranquilo">
                      2. me he sentido tranquilo y relajado
                    </label>
                    <div className="radio--6-col">
                      <label className="radio" htmlFor="who5Tranquilo-5">
                        <input
                          id="who5Tranquilo-5"
                          name="who5Tranquilo"
                          type="radio"
                          value="5"
                          required
                          checked={who5Tranquilo === "5"}
                          onChange={(e) => setWho5Tranquilo(e.target.value)}
                        />
                        5
                      </label>
                      <label className="radio" htmlFor="who5Tranquilo-4">
                        <input
                          id="who5Tranquilo-4"
                          name="who5Tranquilo"
                          type="radio"
                          value="4"
                          required
                          checked={who5Tranquilo === "4"}
                          onChange={(e) => setWho5Tranquilo(e.target.value)}
                        />
                        4
                      </label>
                      <label className="radio" htmlFor="who5Tranquilo-3">
                        <input
                          id="who5Tranquilo-3"
                          name="who5Tranquilo"
                          type="radio"
                          value="3"
                          required
                          checked={who5Tranquilo === "3"}
                          onChange={(e) => setWho5Tranquilo(e.target.value)}
                        />
                        3
                      </label>
                      <label className="radio" htmlFor="who5Tranquilo-2">
                        <input
                          id="who5Tranquilo-2"
                          name="who5Tranquilo"
                          type="radio"
                          value="2"
                          required
                          checked={who5Tranquilo === "2"}
                          onChange={(e) => setWho5Tranquilo(e.target.value)}
                        />
                        2
                      </label>
                      <label className="radio" htmlFor="who5Tranquilo-1">
                        <input
                          id="who5Tranquilo-1"
                          name="who5Tranquilo"
                          type="radio"
                          value="1"
                          required
                          checked={who5Tranquilo === "1"}
                          onChange={(e) => setWho5Tranquilo(e.target.value)}
                        />
                        1
                      </label>
                      <label className="radio" htmlFor="who5Tranquilo-0">
                        <input
                          id="who5Tranquilo-0"
                          name="who5Tranquilo"
                          type="radio"
                          value="0"
                          required
                          checked={who5Tranquilo === "0"}
                          onChange={(e) => setWho5Tranquilo(e.target.value)}
                        />
                        0
                      </label>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <div className="control grid--2col">
                    <label className="radio-title" htmlFor="who5Activo">
                      3. me he sentido activo y con energía
                    </label>
                    <div className="radio--6-col">
                      <label className="radio" htmlFor="who5Activo-5">
                        <input
                          id="who5Activo-5"
                          name="who5Activo"
                          type="radio"
                          value="5"
                          required
                          checked={who5Activo === "5"}
                          onChange={(e) => setWho5Activo(e.target.value)}
                        />
                        5
                      </label>
                      <label className="radio" htmlFor="who5Activo-4">
                        <input
                          id="who5Activo-4"
                          name="who5Activo"
                          type="radio"
                          value="4"
                          required
                          checked={who5Activo === "4"}
                          onChange={(e) => setWho5Activo(e.target.value)}
                        />
                        4
                      </label>
                      <label className="radio" htmlFor="who5Activo-3">
                        <input
                          id="who5Activo-3"
                          name="who5Activo"
                          type="radio"
                          value="3"
                          required
                          checked={who5Activo === "3"}
                          onChange={(e) => setWho5Activo(e.target.value)}
                        />
                        3
                      </label>
                      <label className="radio" htmlFor="who5Activo-2">
                        <input
                          id="who5Activo-2"
                          name="who5Activo"
                          type="radio"
                          value="2"
                          required
                          checked={who5Activo === "2"}
                          onChange={(e) => setWho5Activo(e.target.value)}
                        />
                        2
                      </label>
                      <label className="radio" htmlFor="who5Activo-1">
                        <input
                          id="who5Activo-1"
                          name="who5Activo"
                          type="radio"
                          value="1"
                          required
                          checked={who5Activo === "1"}
                          onChange={(e) => setWho5Activo(e.target.value)}
                        />
                        1
                      </label>
                      <label className="radio" htmlFor="who5Activo-0">
                        <input
                          id="who5Activo-0"
                          name="who5Activo"
                          type="radio"
                          value="0"
                          required
                          checked={who5Activo === "0"}
                          onChange={(e) => setWho5Activo(e.target.value)}
                        />
                        0
                      </label>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <div className="control grid--2col">
                    <label className="radio-title" htmlFor="who5Despejado">
                      4. me he despertado sintiéndome despejado y descansado
                    </label>
                    <div className="radio--6-col">
                      <label className="radio" htmlFor="who5Despejado-5">
                        <input
                          id="who5Despejado-5"
                          name="who5Despejado"
                          type="radio"
                          value="5"
                          required
                          checked={who5Despejado === "5"}
                          onChange={(e) => setWho5Despejado(e.target.value)}
                        />
                        5
                      </label>
                      <label className="radio" htmlFor="who5Despejado-4">
                        <input
                          id="who5Despejado-4"
                          name="who5Despejado"
                          type="radio"
                          value="4"
                          required
                          checked={who5Despejado === "4"}
                          onChange={(e) => setWho5Despejado(e.target.value)}
                        />
                        4
                      </label>
                      <label className="radio" htmlFor="who5Despejado-3">
                        <input
                          id="who5Despejado-3"
                          name="who5Despejado"
                          type="radio"
                          value="3"
                          required
                          checked={who5Despejado === "3"}
                          onChange={(e) => setWho5Despejado(e.target.value)}
                        />
                        3
                      </label>
                      <label className="radio" htmlFor="who5Despejado-2">
                        <input
                          id="who5Despejado-2"
                          name="who5Despejado"
                          type="radio"
                          value="2"
                          required
                          checked={who5Despejado === "2"}
                          onChange={(e) => setWho5Despejado(e.target.value)}
                        />
                        2
                      </label>
                      <label className="radio" htmlFor="who5Despejado-1">
                        <input
                          id="who5Despejado-1"
                          name="who5Despejado"
                          type="radio"
                          value="1"
                          required
                          checked={who5Despejado === "1"}
                          onChange={(e) => setWho5Despejado(e.target.value)}
                        />
                        1
                      </label>
                      <label className="radio" htmlFor="who5Despejado-0">
                        <input
                          id="who5Despejado-0"
                          name="who5Despejado"
                          type="radio"
                          value="0"
                          required
                          checked={who5Despejado === "0"}
                          onChange={(e) => setWho5Despejado(e.target.value)}
                        />
                        0
                      </label>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <div className="control grid--2col">
                    <label className="radio-title" htmlFor="who5Interesan">
                      5. mi vida diaria se ha llenado de cosas que me interesan
                    </label>
                    <div className="radio--6-col">
                      <label className="radio" htmlFor="who5Interesan-5">
                        <input
                          id="who5Interesan-5"
                          name="who5Interesan"
                          type="radio"
                          value="5"
                          required
                          checked={who5Interesan === "5"}
                          onChange={(e) => setWho5Interesan(e.target.value)}
                        />
                        5
                      </label>
                      <label className="radio" htmlFor="who5Interesan-4">
                        <input
                          id="who5Interesan-4"
                          name="who5Interesan"
                          type="radio"
                          value="4"
                          required
                          checked={who5Interesan === "4"}
                          onChange={(e) => setWho5Interesan(e.target.value)}
                        />
                        4
                      </label>
                      <label className="radio" htmlFor="who5Interesan-3">
                        <input
                          id="who5Interesan-3"
                          name="who5Interesan"
                          type="radio"
                          value="3"
                          required
                          checked={who5Interesan === "3"}
                          onChange={(e) => setWho5Interesan(e.target.value)}
                        />
                        3
                      </label>
                      <label className="radio" htmlFor="who5Interesan-2">
                        <input
                          id="who5Interesan-2"
                          name="who5Interesan"
                          type="radio"
                          value="2"
                          required
                          checked={who5Interesan === "2"}
                          onChange={(e) => setWho5Interesan(e.target.value)}
                        />
                        2
                      </label>
                      <label className="radio" htmlFor="who5Interesan-1">
                        <input
                          id="who5Interesan-1"
                          name="who5Interesan"
                          type="radio"
                          value="1"
                          required
                          checked={who5Interesan === "1"}
                          onChange={(e) => setWho5Interesan(e.target.value)}
                        />
                        1
                      </label>
                      <label className="radio" htmlFor="who5Interesan-0">
                        <input
                          id="who5Interesan-0"
                          name="who5Interesan"
                          type="radio"
                          value="0"
                          required
                          checked={who5Interesan === "0"}
                          onChange={(e) => setWho5Interesan(e.target.value)}
                        />
                        0
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </form>
        )}
      </div>
      {!errorMessage && who5.author === pacienteId && (
        <div id="actions">
          {whoStatus === "draft" && (
            <button
              className="button is-link"
              id="saveButton"
              form="formUpdatelement"
              type="submit"
              disabled={isCreatingButton}
            >
              {isCreatingButton ? <div className="spinner"></div> : "Guardar"}
            </button>
          )}
        </div>
      )}
      <GananciasModal
        isOpen={isGananciasModalOpen}
        onClose={() => window.location.replace("../")}
        title="Ganancias obtenidas"
        message={gananciasMessage}
        buttonStyle="is-danger"
      />
    </>
  );
}
